import { useSeo } from "@/hooks/use-seo";
import { useTranslation } from "@/i18n/useTranslation";
import { Hero } from "@/components/sections/Hero";
import { Trust } from "@/components/sections/Trust";
import { Pillars } from "@/components/sections/Pillars";
import { Features } from "@/components/sections/Features";
import { HowItWorks } from "@/components/sections/HowItWorks";
import { Integrations } from "@/components/sections/Integrations";
import { Pricing } from "@/components/sections/Pricing";
import { FAQ } from "@/components/sections/FAQ";
import { CTA } from "@/components/sections/CTA";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";

export default function Home() {
  const { t } = useTranslation();

  useSeo({
    title: t("hero.title.before").trim() + " " + t("hero.title.accent") + t("hero.title.after") + " — CookieRobot",
    description: t("hero.subtitle"),
    url: "https://cookierobot.info/",
    keywords: "Cookie-Banner, DSGVO, Consent-Management, ePrivacy, TTDSG",
  });

  return (
    <div className="min-h-screen flex flex-col w-full bg-background text-foreground">
      <Header />
      <main className="flex-1 w-full flex flex-col">
        <Hero />
        <Trust />
        <Pillars />
        <Features />
        <HowItWorks />
        <Integrations />
        <Pricing />
        <FAQ />
        <CTA />
      </main>
      <Footer />
    </div>
  );
}
